// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapseMenu_container__Ewo08","icon":"CollapseMenu_icon__j1M47","withinScrollableArea":"CollapseMenu_withinScrollableArea__Eor36","bar":"CollapseMenu_bar__goNR1"};